import axiosClient from 'api/shared/AxiosClient';
import { dateRangeUriEncode } from 'utils/Utils';

class CampaignService {

    getNotificationList = (dateRanges) => {
        if (dateRanges) {
            return {
                method: 'get',
                url: `/campaigns?${dateRangeUriEncode(dateRanges)}`,
            }
        } else {
            return {
                method: 'get',
                url: `/campaigns`,
            }
        }

    }

    updateNotification = async (id, data) => {
        const resp = await axiosClient.post(
            `/campaigns/edit/${id}`, data);
        if (resp.data) {
            return (resp.data);

        } else {
            throw new Error("Something went wrong!");
        }
    }
    cancelNotification = async (id) => {
        const resp = await axiosClient.post(
            `/campaigns/cancel/${id}`, {
            _id: "3",
            label: "canceled"
        });
        if (resp.data) {
            return (resp.data);

        } else {
            throw new Error("Something went wrong!");
        }
    }


    deleteNotification = async (id) => {
        const resp = await axiosClient.delete(
            `/campaigns/${id}`);

        if (resp.data) {
            return (resp.data);

        } else {
            throw new Error("Something went wrong!");
        }

    }

    createNotification = async (data) => {
        const resp = await axiosClient.post(
            `/campaigns/create`, data);
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }

    }

    getNotificationListWithPagination = async (limit, skip, search) => {
        const resp = await axiosClient.get(`campaigns/list?limit=${limit}&skip=${skip}&search=${search}`);
        if (resp.data) {
            return (resp.data);
        } else {
            throw new Error("Something went wrong!");
        }

    }
}

const campaignService = new CampaignService();
export default campaignService;




